export const supportLabel = {
    name: "Support",
    plural: "Support",
    // Used in routes and navigation
    pathName: "support",
    value: "support",
  };
  